import _ from 'lodash';
import update from 'immutability-helper';
import qwPartners from '../common/clients/qwPartners';
import I18n from '../../config/i18n';
import { formatTerritories } from '../common/utils/region';
import enums from '../common/utils/enums';
import { convertToBps } from '../common/utils';
import {
  deleteServiceAreas,
  formatDeliveryOptions,
  formatTheatreLists,
} from './serviceAreas';
import {
  deleteCompanyDetails,
  expandCompanyBusinessHours,
} from './companyDetails';
import { handleAppError, showAppBusy } from './app';

const initialState = { registrationStatus: '' };

const UPDATE_REGISTRATION_STATUS = 'register/UPDATE_REGISTRATION_STATUS';

function updateRegistrationStatus(payload) {
  return { type: UPDATE_REGISTRATION_STATUS, payload };
}

export function cancelRegistration() {
  return (dispatch) => {
    dispatch(deleteCompanyDetails());
    dispatch(deleteServiceAreas());
  };
}

function getFinalDrivesData(drives) {
  if (!drives[0].totalStock) {
    drives[0].totalStock = 0;
  }

  return drives;
}

export function agreeRegistration() {
  return (dispatch, getState) => {
    if (getState().companyDetails.businessHours.length < 7) {
      dispatch(expandCompanyBusinessHours());
    }

    let state = getState();
    let { phones, emails, timezone, businessHours } = state.companyDetails;
    let { drives, bandwidth } = state.inventory;
    let certifications = state.certifications;
    let serviceAreas = _.cloneDeep(state.serviceAreas.serviceAreas).map(
      (serviceArea) => {
        formatDeliveryOptions(serviceArea);
        return _.extend(formatTerritories([serviceArea], state.regions), {
          deliveryType: serviceArea.deliveryType,
        });
      },
    );
    const theatreLists = formatTheatreLists(
      _.cloneDeep(state.serviceAreas.theatreLists),
    );
    serviceAreas = _.concat(serviceAreas, theatreLists);

    let _drives = getFinalDrivesData(drives);
    let bandwidthInBps = Math.round(convertToBps(bandwidth));

    let data = {
      phones,
      emails,
      timezone,
      businessHours,
      serviceAreas,
      drives: _drives,
      bandwidth: bandwidthInBps,
      certifications,
    };

    dispatch(showAppBusy(true));

    return qwPartners
      .post(`/v1/approvals/${data.id || ''}`, data)
      .then(() => {
        dispatch(showAppBusy(false));
        dispatch(updateRegistrationStatus(enums.RegistrationSteps.SUCCESS));
      })
      .catch((error) => {
        dispatch(showAppBusy(false));
        dispatch(handleAppError(error, I18n.t('couldNotSubmitRegistration')));
      });
  };
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case UPDATE_REGISTRATION_STATUS:
      return update(state, { registrationStatus: { $set: payload } });

    default:
      return state;
  }
}
